import * as React from "react"
import { useState, useEffect } from "react"
import "../../styles/fonts.css"
import PropTypes from "prop-types"
import Header from "../Globals/Header/Header"
import Footer from "../Globals/Footer/Footer"
import { get } from "../../helpers/utils"
import ScriptWrapper from "../Wrappers/ScriptWrapper/ScriptWrapper"
import createStore from "../../redux/store"
import { Provider } from "react-redux"
import { JumpToMainContent } from "../../constants/label.constants"
import Typography from "../UI/Typography/Typography"
import Button from "../UI/Button/Button"

const Layout = ({
  children,
  seoData,
  slug,
  globalComponents,
  topDisclaimer,
  hasMoreLessButton,
  preloadComp,
  pageType,
}) => {
  const FooterProps = globalComponents?.find(component => component?.Footer)
  const HeaderProps = globalComponents?.find(component => component?.Header)
  const footerCollection = get(
    FooterProps,
    "Footer.footerCollection.items[0]",
    {}
  )

const footerForSubPages = {...footerCollection}
footerForSubPages.mainLinksCollection= {
  "items": [
    {
      "title": "MONDELEZ INDIA",
      "linksCollection": {
          "items": [
              {
                  "__typename": "Link",
                  "label": "Snacking Made Right",
                  "title": null,
                  "url": "/India/India-business/snacking-made-right",
                  "target": "_blank",
                  "scrollToElementId": null,
                  "gaEventClass": "event_external_link",
                  "gaEventLabel": "Snacking Made Right",
                  "image": null
              },
              {
                  "__typename": "Link",
                  "label": "Cocoa Life",
                  "title": null,
                  "url": "/India/India-business/cocoa-life",
                  "target": "_blank",
                  "scrollToElementId": null,
                  "gaEventClass": "event_external_link",
                  "gaEventLabel": "Cocoa Life",
                  "image": null
              },
              {
                "__typename": "Link",
                "label": "Community Initiatives",
                "title": null,
                "url": "/India/India-Business/community-initiatives",
                "target": "_blank",
                "scrollToElementId": null,
                "gaEventClass": "event_external_link",
                "gaEventLabel": "Community Initiatives",
                "image": null
              },
              {
                "__typename": "Link",
                "label": "Mindful Snacking",
                "title": null,
                "url": "https://www.snackmindful.com/",
                "target": "_blank",
                "scrollToElementId": null,
                "gaEventClass": "event_external_link",
                "gaEventLabel": "Mindful Snacking",
                "image": null
              },
              {
                "__typename": "Link",
                "label": "COVID 19 Relief Efforts",
                "title": null,
                "url": "/india/esg/covid-19-relief-efforts/",
                "target": "_blank",
                "scrollToElementId": null,
                "gaEventClass": "event_external_link",
                "gaEventLabel": "COVID 19 Relief Efforts",
                "image": null
              }
          ]
      }
    },
    {
          "title": "CONTACT US",
          "linksCollection": {
              "items": [
                  {
                      "__typename": "Link",
                      "label": "Consumers",
                      "title": null,
                      "url": "/Contact-Us/Consumers/",
                      "target": "_self",
                      "scrollToElementId": null,
                      "gaEventClass": "event_internal_link",
                      "gaEventLabel": "Consumers",
                      "image": null
                  },
                  {
                      "__typename": "Link",
                      "label": "Investors",
                      "title": null,
                      "url": "/Investors/IR-Contacts/",
                      "target": "_self",
                      "scrollToElementId": null,
                      "gaEventClass": "event_internal_link",
                      "gaEventLabel": "Investors",
                      "image": null
                  },
                  {
                      "__typename": "Link",
                      "label": "Media",
                      "title": null,
                      "url": "/Media/Media-Contacts/",
                      "target": "_self",
                      "scrollToElementId": null,
                      "gaEventClass": "event_internal_link",
                      "gaEventLabel": "Media",
                      "image": null
                  }
              ]
          }
    }   
  ]
}

  const headerCollection = get(
    HeaderProps,
    "Header.headerCollection.items[0]",
    {}
  )
  const store = createStore()

  const TopDisc = topDisclaimer?.topDisclaimer
  const [start, setStart] = useState(0)
  const [end, setEnd] = useState(273)
  const [showMore, setShowMore] = useState(true)

  const handleMoreClick = () => {
    setStart(0)
    setEnd(TopDisc.length)
    setShowMore(false)
  }

  const handleLessClick = () => {
    setStart(0)
    setEnd(272)
    setShowMore(true)
  }

  const hideHeaderFooter = slug?.includes("Canada")
  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathName = window.location.pathname
      const slug = pathName
        .split("/")
        .filter(ele => ele)
        .pop()
        if(document.body.classList){
          if(pathName?.includes('/india/india-business/snacking-made-right') || pathName?.includes('/india/india-business/cocoa-life')|| pathName?.includes('/india/india-business/community-initiatives/')){
            document.body.classList.add(`india-bu-${slug}`)
          }
          else{
            document.body.classList.add(slug)
          }
        }else {
         if(pathName?.includes('/india/india-business/snacking-made-right') || pathName?.includes('/india/india-business/cocoa-life')|| pathName?.includes('/india/india-business/community-initiatives/')){
            document.body.setAttribute("class", `india-bu-${slug}`)
          }
          else{
            document.body.setAttribute("class", slug)
          }
        }
     
    }
  }, [])

  const footerSpecificCollection = () => { 
    if(slug?.includes('/India/India-Business/snacking-made-right') || slug?.includes('/India/India-Business/cocoa-life')|| slug?.includes('/India/India-Business/community-initiatives/')){
      return footerForSubPages
    }
    else {
      return footerCollection
    }
  }
  return (
    <>
      <ScriptWrapper seoHead={seoData} slug={slug} preloadComp={preloadComp} />
      {slug === "/" && 
        <section className="sr-only">
          <h1>Welcome to Mondelēz International, Inc</h1>
        </section>
      }
      <Provider store={store}>
        <div media="print" className="main-container text-black">
          <nav
            aria-label="Accessibility Navigation"
            hidden=""
            className="access-nav"
          >
            <a className="show-on-focus" href="#global-header">
              Jump to Header
            </a>
            <a className="show-on-focus" href="#global-main-content">
              Jump to Main Content
            </a>
            <a className="show-on-focus" href="#global-footer">
              Jump to Footer
            </a>
          </nav>
          {topDisclaimer &&
            (hasMoreLessButton ? (
              <div className="topDiscclam" role="alert">
                {" "}
                <p>
                  {TopDisc.slice(start, end)}
                  {showMore && <Button onClick={handleMoreClick}>MORE</Button>}
                  {!showMore && <Button onClick={handleLessClick}>LESS</Button>}
                </p>
              </div>
            ) : (
              <div className={hideHeaderFooter?"topDiscclam topDiscclamWhite":"topDiscclam"} role="alert">
                <Typography content={TopDisc} />
              </div>
            ))}
            <Header {...headerCollection} hideHeader={hideHeaderFooter} />
          <div
            className="content-container algolia-container"
            id={JumpToMainContent}
            data-nosnippet={true}
          >
            <main className={pageType=="Vietnam Page" ? "vietnamPageFont" : ""}>{children}</main>
          </div>
            <Footer {...footerSpecificCollection()} hideFooter={hideHeaderFooter} slug = {slug} />
        </div>
      </Provider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  seoData: PropTypes.object,
  globalComponents: PropTypes.array,
  topDisclaimer: PropTypes.object,
  hasMoreLessButton: PropTypes.bool,
  preloadComp: PropTypes.object,
  slug: PropTypes.string,
  pageType: PropTypes.string,
}

export default Layout